export interface ISelectOption<T> {
  label: string;
  value: T;
}

export interface ISelectOptionGroup<T> {
  label: string;
  options: ISelectOption<T>[];
}
